import { Dispatcher } from '@npm-registry/helpers/dispatcher';
import { ProductWithAnalytics } from '../../store/products/types';

type ProductDispatcherData = [data: ProductWithAnalytics];

// Начало добавления товар в корзину
export const OnBeforeProductAdd =
  new Dispatcher<ProductDispatcherData>();

// Момент перед отправкой запроса на добавление
export const OnProductAdd =
  new Dispatcher<ProductDispatcherData>();

// Успешное добавление товара
export const OnAfterProductAdd =
  new Dispatcher<ProductDispatcherData>();

// Успешное увеличение количества товара
export const OnAfterProductIncrease =
  new Dispatcher<ProductDispatcherData>();

// Успешное уменьшение количества товара
export const OnAfterProductDecrease =
  new Dispatcher<ProductDispatcherData>();

// Товар помечен на удаление товара
export const OnAfterProductMarkForDeletion =
  new Dispatcher<ProductDispatcherData>();

// Успешное изменение количества товара
export const OnAfterProductInputQuantity =
  new Dispatcher<ProductDispatcherData>();

// Успешное возвращение товара из удаленных
export const OnAfterProductCancelDeletion =
  new Dispatcher<ProductDispatcherData>();

// Нажата кнопка удаления товара
export const OnAfterClickProductDeleteButton =
  new Dispatcher<ProductDispatcherData>();
